export default "__VITE_ASSET__DMPBLInK__"